<div id="attachmentContainer">
  <div class="attachment-header">
    <h4>{{ "App.Outlook.FileReader.Title" | translate }}</h4>
  </div>

  @for (attachment of attachments; track attachment) {
    <div class="attachment">
      <div class="selected-card" [ngClass]="{ selected: isSelected(attachment) }">
        <sdx-card label-aria-level="1" class="attachment-card" (click)="toggleAttachment(attachment)">
          <div class="attachment-row">
            <span class="icon-underline">
              <i class="icon" [ngClass]="getAttachmentIconClass(attachment.name)" aria-hidden="true"></i>
            </span>
            <div class="attachment-details">
              <span class="h5">{{ attachment.name }}</span>
              <p>{{ attachment.size }} KB</p>
            </div>
            @if (isSelected(attachment)) {
              <i class="icon icon-tick selection-indicator" aria-hidden="true"></i>
            }
          </div>
        </sdx-card>
      </div>
    </div>
  }
</div>
